import { useContext } from 'react';
import ProductConfigurationContext from '../components/ProductConfigurationProvider/ProductConfigurationContext';
/** Will return either the configuration, variation, or base product price */
export function useDynamicPrice(product, variant) {
    const configurationContext = useContext(ProductConfigurationContext);
    // If we have a configuration, return the price.
    // Products with configurations cannot have variants.
    if (configurationContext === null || configurationContext === void 0 ? void 0 : configurationContext.configurationPrice) {
        return configurationContext.configurationPrice;
    }
    // If a variant is selected, return the price of the variant
    if (variant) {
        const { price, previousPrice } = variant;
        return {
            price,
            previousPrice
        };
    }
    // Otherwise, just return the base product price
    return {
        price: product === null || product === void 0 ? void 0 : product.price,
        previousPrice: product === null || product === void 0 ? void 0 : product.previousPrice
    };
}
//# sourceMappingURL=useDynamicPrice.js.map